module.exports = __webpack_public_path__ + "static/media/night-cloud-rain-icon.c0b65518.svg";